import React from "react";
import { IManagementStore } from "@src/Stores/Management/types";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { STFormContentWrapper, STTabsContentWrapper } from "./styles";
import { Grid, Tabs, Tab } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { IValuesStore } from "@src/Stores/Values/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import LimitsForm from "./LimitsForm/LimitsForm";
import DatabaseForm from "./DatabaseForm/DatabaseForm";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
export default class SystemSettings extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable tabIndex: number = 0;

  async componentDidMount() {
    await this.props.management.getSystemSettings();
    this.isLoading = false;
    document.title = Values.getLocalizationValue("systemSettings");
  }

  handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.tabIndex = newValue;
  };

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }
    const { management } = this.props;
    const initialValues = {
      maxActiveUsers: management.systemSettings.maxActiveUsers,
    };
    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <STPageHeader>{Values.getLocalizationValue("systemSettings")}</STPageHeader>
        </Grid>
        <STTabsContentWrapper>
          <Tabs
            value={this.tabIndex}
            onChange={this.handleTabIndexChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label={Values.getLocalizationValue("limits")} />
            <Tab label={Values.getLocalizationValue("database")} />
          </Tabs>
          <STFormContentWrapper>
            {this.tabIndex === 0 && (
              <div>
                <LimitsForm initialValues={initialValues} />
              </div>
            )}
            {this.tabIndex === 1 && (
              <div>
                <DatabaseForm initialValues={initialValues} />
              </div>
            )}
          </STFormContentWrapper>
        </STTabsContentWrapper>
      </Grid>
    );
  }
}
